module.exports = __webpack_public_path__ + "media/images/games/35gender/pop-17bc5dbdf26cb83be23fdbaab81719cf.png";